<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="po_number"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.po_number"
        :form-state="formState"
        name="po_number"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.po_number"
        @input="updateDatePoSupplied"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="date_po_supplied"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        :readonly="true"
        v-model="item.date_po_supplied"
        name="date_po_supplied"
        v-bind="schema.fields.date_po_supplied"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="po_supplied_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.po_supplied_by"
        :form-state="formState"
        name="po_supplied_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.po_supplied_by"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="invoice_number"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.invoice_number"
        :form-state="formState"
        name="invoice_number"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.invoice_number"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="date_invoiced"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.date_invoiced"
        name="date_invoiced"
        v-bind="schema.fields.date_invoiced"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <!-- <o-widget-wrapper
      :schema="schema"
      name="invoiced_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        flat
        clearable
        v-model="item.invoiced_by"
        :items="optionUserItems"
        text-field="username"
        value-field="id"
        :validator="$v.item[schema.fields.invoiced_by.name]"
        :loading="optionUserWorking"
        name="invoiced_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.invoiced_by"
        :form-state="formState"
      ></o-select>
    </o-widget-wrapper> -->
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import moment from "moment";
// import { default as UserForm } from '../../user/components/ItemForm';

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ServicePurchaseOrder"),
    CreateCodeTableFetchMixin(["User"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    /* UserForm, */
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.ServicePurchaseOrder, {}),
  }),
  methods: {
    updateDatePoSupplied(){
      if (this.item.po_number && !this.item.date_po_supplied) {
        var current = moment().format("YYYY-MM-DD");
        this.item.date_po_supplied = current;
      }
    }
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
